import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";

const VERSES = [
  { text: "For God so loved the world that he gave his only Son, that whoever believes in him should not perish but have eternal life.", ref: "John 3:16" },
  { text: "Go into all the world and preach the gospel to the whole creation.", ref: "Mark 16:15" },
  { text: "I am the way, and the truth, and the life.", ref: "John 14:6" },
  { text: "I can do all things through him who strengthens me.", ref: "Philippians 4:13" },
  { text: "Be still, and know that I am God.", ref: "Psalm 46:10" },
  { text: "The Lord is my shepherd; I shall not want.", ref: "Psalm 23:1" },
  { text: "Your body is a temple of the Holy Spirit within you.", ref: "1 Corinthians 6:19" },
  { text: "Beloved, I pray that all may go well with you and that you may be in good health, as it goes well with your soul.", ref: "3 John 1:2" },
  { text: "Trust in the Lord with all your heart, and do not lean on your own understanding.", ref: "Proverbs 3:5" },
  { text: "Go therefore and make disciples of all nations.", ref: "Matthew 28:19" },
  { text: "The joy of the Lord is your strength.", ref: "Nehemiah 8:10" },
  { text: "He heals the brokenhearted and binds up their wounds.", ref: "Psalm 147:3" },
  { text: "Cast all your anxiety on him because he cares for you.", ref: "1 Peter 5:7" },
  { text: "Let the little children come to me, and do not hinder them.", ref: "Matthew 19:14" },
];

// Pick a deterministic "verse of the day" anchor so dashboard shows a stable one per day
function verseOfTheDayIndex() {
  const d = new Date();
  const dayOfYear = Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000);
  return dayOfYear % VERSES.length;
}

export default function VerseRotator({ variant = "hero", intervalMs = 7000 }) {
  const initial = variant === "daily" ? verseOfTheDayIndex() : 0;
  const [idx, setIdx] = useState(initial);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    if (variant === "daily") return; // daily = fixed for the day
    const t = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % VERSES.length);
        setFade(true);
      }, 350);
    }, intervalMs);
    return () => clearInterval(t);
  }, [intervalMs, variant]);

  const v = VERSES[idx];

  if (variant === "daily") {
    return (
      <div data-testid="verse-daily" className="faith-card p-6 border-2" style={{borderColor:'#F39A1F'}}>
        <div className="flex items-center gap-2 mb-3">
          <BookOpen className="w-5 h-5 text-gold-deep" />
          <div className="text-xs tracking-wider-cap text-gold-deep">Verse of the Day</div>
        </div>
        <blockquote className="font-serif-display text-xl md:text-2xl text-foreground leading-snug">"{v.text}"</blockquote>
        <div className="mt-3 text-sm text-red-wine font-semibold">— {v.ref}</div>
      </div>
    );
  }

  return (
    <div data-testid="verse-rotator" className="mx-auto max-w-3xl mt-8">
      <div className={`transition-opacity duration-300 ${fade ? "opacity-100" : "opacity-0"}`}>
        <blockquote className="font-serif-display italic text-xl md:text-2xl text-foreground leading-relaxed">
          <span className="text-gold-deep font-serif-display text-3xl align-top leading-none mr-1">"</span>
          {v.text}
          <span className="text-gold-deep font-serif-display text-3xl align-top leading-none ml-1">"</span>
        </blockquote>
        <div className="mt-2 text-sm tracking-wider-cap text-red-wine font-semibold">— {v.ref}</div>
      </div>
      <div className="flex justify-center gap-1.5 mt-4">
        {VERSES.map((_, i) => (
          <span key={i} className={`h-1 rounded-full transition-all ${i === idx ? "w-8 bg-[#F39A1F]" : "w-2 bg-border"}`} />
        ))}
      </div>
    </div>
  );
}
